import Vue from 'vue'
import Vuex from 'vuex'

import { Rota } from '../types/Rotas'

Vue.use(Vuex)

const getters = {
  ROLES: (state: any) => state.roles,
  ROTAS: (state: any) => state.rotas,
  SHOW: (state: any) => state.show,
}

const actions = {}

const mutations = {
  ROLES (context: any, roles) {
    context.roles = roles
  },

  ROTAS (context: any, rotas) {
    context.rotas = rotas
  },

  SHOW (context: any, show) {
    context.show = show
  },
}

const rotas: Array<Rota> = []

export default new Vuex.Store({
  state: {
    show: true,
    rotas: rotas,
    roles: [''],
  },
  getters: getters,
  actions: actions,
  mutations: mutations,
})
